import { render, staticRenderFns } from "./standardCommonSubFolder.vue?vue&type=template&id=83c50986&scoped=true"
import script from "./standardCommonSubFolder.vue?vue&type=script&lang=js"
export * from "./standardCommonSubFolder.vue?vue&type=script&lang=js"
import style0 from "./standardCommonSubFolder.vue?vue&type=style&index=0&id=83c50986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c50986",
  null
  
)

export default component.exports